import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-xl mx-auto px-4 py-24 text-center">
      <XCircle className="h-12 w-12 text-gray-500 mx-auto mb-5" />
      <h1 className="font-heading font-bold text-white text-2xl">Checkout cancelled</h1>
      <p className="text-gray-400 mt-2">No charge was made. You can pick up right where you left off.</p>
      <Link to="/author-program" data-testid="payment-cancel-back"
        className="inline-block mt-8 bg-[#7C3AED] text-white font-bold px-6 py-2.5 rounded-md hover:bg-[#6a2dd0] transition-colors">
        Back to the Author Program
      </Link>
    </div>
  );
}
